var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgorithms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    id: "Algorithms",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#770078",
    className: "stopColor000092 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a14397",
    className: "stopColorff00f3 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2,
    x2: 27,
    y1: 16.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M17 4a2.506 2.506 0 0 0-2.5 2.5c0 1.204.863 2.213 2 2.447V11h-7a.5.5 0 0 0-.5.5v2.55h-.002A2.508 2.508 0 0 0 7 16.5c0 1.204.863 2.213 2 2.447V21H4.5a.5.5 0 0 0-.5.5v2.55a2.508 2.508 0 0 0-2 2.45C2 27.876 3.124 29 4.5 29S7 27.876 7 26.5a2.508 2.508 0 0 0-2-2.45V22h9v2.05a2.508 2.508 0 0 0-2 2.45c0 1.376 1.124 2.5 2.5 2.5s2.5-1.124 2.5-2.5a2.508 2.508 0 0 0-2-2.45V21.5a.5.5 0 0 0-.5-.5H10v-2.053h.002A2.506 2.506 0 0 0 12 16.5a2.51 2.51 0 0 0-2-2.45V12h14v2.05h-.002A2.508 2.508 0 0 0 22 16.5c0 1.204.86 2.213 1.998 2.447V21.5a.5.5 0 0 0 .5.5H27v2.05h-.002A2.508 2.508 0 0 0 25 26.5c0 1.376 1.124 2.5 2.5 2.5s2.5-1.124 2.5-2.5a2.51 2.51 0 0 0-2-2.45V21.5a.5.5 0 0 0-.5-.5h-2.502v-2.053A2.506 2.506 0 0 0 27 16.5a2.51 2.51 0 0 0-2-2.45V11.5a.5.5 0 0 0-.5-.5h-7V8.947h.002A2.506 2.506 0 0 0 19.5 6.5C19.5 5.124 18.376 4 17 4zm0 1c.84 0 1.5.66 1.5 1.5 0 .813-.622 1.453-1.424 1.492a.5.5 0 0 0-.084-.006.5.5 0 0 0-.072.006c-.8-.041-1.42-.68-1.42-1.492 0-.84.66-1.5 1.5-1.5zM9.457 15.004h.002a.5.5 0 0 0 .078 0c.821.02 1.463.67 1.463 1.496 0 .813-.622 1.453-1.424 1.492a.5.5 0 0 0-.084-.006.5.5 0 0 0-.072.006C8.62 17.951 8 17.312 8 16.5c0-.825.639-1.473 1.457-1.496zm15 0h.002a.5.5 0 0 0 .078 0c.821.02 1.463.67 1.463 1.496 0 .824-.637 1.471-1.453 1.496a.5.5 0 0 0-.057-.002.5.5 0 0 0-.035.002A1.483 1.483 0 0 1 23 16.5c0-.825.639-1.473 1.457-1.496zm-20 10h.002a.5.5 0 0 0 .078 0c.821.02 1.463.67 1.463 1.496 0 .84-.66 1.5-1.5 1.5S3 27.34 3 26.5c0-.825.639-1.473 1.457-1.496zm10 0h.002a.5.5 0 0 0 .078 0c.821.02 1.463.67 1.463 1.496 0 .84-.66 1.5-1.5 1.5s-1.5-.66-1.5-1.5c0-.825.639-1.473 1.457-1.496zm13 0h.002a.5.5 0 0 0 .078 0c.821.02 1.463.67 1.463 1.496 0 .84-.66 1.5-1.5 1.5s-1.5-.66-1.5-1.5c0-.825.639-1.473 1.457-1.496z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorithms);
export default __webpack_public_path__ + "static/media/algorithms.ff8abd1cd2cf38073beed63148efa179.svg";
export { ForwardRef as ReactComponent };